<template>
  <b-container>
    <b-row>
      <b-col v-if="model.attachments.length > 0" class="pl-4 pr-1">
        <b-btn data-test-path="documents-button" @click="downloadFile"
               variant="link" class="m-1" style="width: 42px">
          <font-awesome-icon icon="paperclip"/>
        </b-btn>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

export default {
  name: "DocumentsRenderer",
  components: {},
  mounted() {},

  methods: {
    async downloadFile() {
      try {
        window.location.href = this.model.attachments[0].downloadUrl;
      } catch (error) {
        console.error($tr("documentsRenderer.error.while.downloading.file", "An error occurred while downloading the file."));
      }
    },
  },

  props: ["rowIndex", "prop", "model", "column"],

  watch: {
  },

  data: () => ({
    labels: [],
    labelsInfo: [],
  }),
};
</script>

<style scoped>
</style>